import { isPresent } from 'helpers/verify';
import { glsLocation } from 'redux/saga/entities/bound';
export function selectGlsLocationFromCoordinates(state, coordinates) {
  var _ref = coordinates || {},
      lat = _ref.lat,
      lon = _ref.lon;

  if (isPresent(lat) && isPresent(lon)) {
    return glsLocation.data(state, glsLocation.defaultKey(null, lat, lon));
  }
}